// Dictionnaire NÉERLANDAIS, assemblé par fragments, exactement comme fr/.
// Chaque fragment porte les mêmes clés que son homologue de fr/ ; l'objet
// final est plat : 'espace.cle' -> texte.
//
// NB : nl/common.js porte en plus les clés packs.<id>.<champ>, qui n'existent
// pas côté français (en français les textes produit viennent de la base ;
// tp()/tpList() ne lisent ces clés que pour les autres langues).
import common from './common';
import home from './home';
import experience from './experience';
import shop from './shop';
import fiche from './fiche';
import tunnel from './tunnel';
import regles from './regles';
import divers from './divers';

export default {
  ...common,
  ...home,
  ...experience,
  ...shop,
  ...fiche,
  ...tunnel,
  ...regles,
  ...divers,
};
